import React from "react";
import { defaultOutletContextState, IOutletContextState } from "./OutletContext.types";



export const OutletContext = React.createContext<IOutletContextState>(defaultOutletContextState);